import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MessageService } from '../../services/message.service';
import { SharedService } from '../../services/shared.service';

@Component({
  standalone: false,
  selector: 'app-upload',
  templateUrl: './upload.component.html',
})

export class UploadComponent {
  @Input() uploadFormData: boolean;
  @Input() typePicture: boolean;
  formData = new FormData();
  @Output() readonly inputChange = new EventEmitter();

  constructor(private sharedService: SharedService,
              private message: MessageService) {
  }

  addFile(event: any): void {
    if (event.target.files && event.target.files.length) {
      this.formData = new FormData();
      const file = event.target.files[0];

      if (file) {
        this.formData.append('file', file);

        const fileReader = new FileReader();

        //If file is an image
        if (file.type.split('/')[0] === 'image') {
          fileReader.onloadend = () => {
            this.inputChange.emit(this.formData);
            //Handle file upload in parent component
          }
        }
        
        //If file is not an image
        else {
          fileReader.onloadend = () => {
            this.sharedService.uploadFile(this.formData).subscribe(
              res => {
                if (this.uploadFormData) {
                  this.inputChange.emit({formData: this.formData, fileName: res.results});
                } else {
                  this.inputChange.emit(res.results);
                }
              },
              err => {
                this.message.error(err);
              }
            );
          };
        }
        fileReader.readAsDataURL(file);
        event.target.value = '';
      }
    }
  }
}
